import { useCallback } from 'react';
import * as LancamentosAPI from '../../../../api/lancamentos';
import { corrigirDataColumnFiltersObjeto } from '../../../../utils/funcoes';

export function useFinanceiroListModule({ mrt, tipo, setLancamentos }) {
    const fetchData = useCallback(async () => {
        try {
            if (!Array.isArray(mrt?.columnFilters)) return;

            if (!mrt.rowCount) {
                mrt.setIsLoading(true);
            } else {
                mrt.setIsRefetching(true);
            }

            const filtrosCorrigidos = corrigirDataColumnFiltersObjeto(mrt.columnFilters);

            const response = await LancamentosAPI.listar(
                mrt.pagination.pageIndex * mrt.pagination.pageSize,
                mrt.pagination.pageSize,
                JSON.stringify(filtrosCorrigidos ?? []),
                JSON.stringify(mrt.columnFilterFns ?? {}),
                mrt.globalFilter ?? '',
                JSON.stringify(mrt.sorting ?? []),
                tipo
            );

            setLancamentos(response.data.data);
            mrt.setRowCount(response.data.meta.totalRowCount);
            mrt.setIsError(false);
        } catch (error) {
            console.error(error);
            mrt.setIsError(true);
        } finally {
            mrt.setIsLoading(false);
            mrt.setIsRefetching(false);
        }
    }, [
        tipo,
        setLancamentos,
        mrt.columnFilters,
        mrt.columnFilterFns,
        mrt.globalFilter,
        mrt.pagination.pageIndex,
        mrt.pagination.pageSize,
        mrt.sorting,
    ]);

    return {
        fetchData,
    };
}
